Service.create = function (node) {
    var service = new Service();

    service.label = Utils.getNextDefaultLabel(node.services, "Service", 1);
    service.id = Utils.getNextDefaultId(node.services, "service", 1);
    service.type = "script";
    service.content = {};

    service.bind(node);

    return service;
};

Service.bind = function (node, service) {
    Utils.inheritMethods(service, new Service());

    service.bind(node);

    return service;
};

/**
 *
 * @constructor
 */
function Service() {
    /**
     *
     */
    Service.prototype.bind = function (node) {
        this.class = "Service";
        this.__node = node;
    };
}
